"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedTaxReportGenerateResponse = exports.mockedTaxReportGenerateRequest = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const country_1 = require("../country");
const legal_entity_1 = require("../legal-entity");
const tax_rate_1 = require("../tax-rate");
exports.mockedTaxReportGenerateRequest = {
  periodFrom: new Date(),
  periodTo: new Date(),
  noZeroTaxRates: true,
  countryRegion: common_interfaces_1.CountryRegionAbv.europe,
  productType: common_interfaces_1.ProductType.project,
  legalEntityId: legal_entity_1.mockedLegalEntityResponse.id
};
exports.mockedTaxReportGenerateResponse = {
  country: country_1.mockedCountryResponse,
  rateName: tax_rate_1.mockedTaxRateResponse.name,
  rate: tax_rate_1.mockedTaxRateResponse.history[0].rate,
  quantityOfBuyers: 1,
  quantityOfPayments: 1,
  payedSumInEuro: 100,
  taxSumForTurnover: 10,
  payedSumWithoutTurnover: 90
};